/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  PlanAnnotationsResponse,
  PlanRevisionActiveDraftResponse,
  PlanRevisionCommitRequest,
  PlanRevisionDraftResponse,
  PlansAnnotationsByPageIdGetV2Params,
  PlansAnnotationsByPageIdPutV2Params,
  PlansByPageIdDeleteV2Params,
  PlansByPageIdGetV2Params,
  PlansBySetIdGetV3Params,
  PlansDownloadSetBySetIdPostV2Params,
  PlansDownloadSetFileBySetIdAndHashGetV2Params,
  PlanSetDownloadResponse,
  PlansExternalSetsDownloadSetBySetIdPostV2Params,
  PlansFileByPageIdGetV2Params,
  PlansGetPageResponse,
  PlansGetResponse,
  PlansGetV2Params,
  PlansHistoryByPageIdGetV2Params,
  PlansNotifyRequest,
  PlansProcessPostV2Params,
  PlansProcessRevisionsUploadRequest,
  PlansProcessRevisionsUploadRequestV3,
  PlansProcessUploadRequest,
  PlansRenamePagePutV2Params,
  PlansRenameSetPutV2Params,
  PlansReorderPagesPutV2Params,
  PlansReorderSetsPutV2Params,
  PlansRevisionsActiveGetV2Params,
  PlansRevisionsByDraftIdDeleteV2Params,
  PlansRevisionsByDraftIdGetV2Params,
  PlansRevisionsCommitByDraftIdPostV2Params,
  PlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2Params,
  PlansRevisionsProcessPostV2Params,
  PlansRevisionsProcessPostV3Params,
  PlansSetBySetIdDeleteV2Params,
  PlansSharePostV2Params,
  PlansShareResponse,
  PlansThumbnailByPageIdAndRowVersionGetV2Params,
  PlansUploadResponse,
  PlansVersionByPageIdPostV2Body,
  PlansVersionByPageIdPostV2Params,
  PlanVersionHistoryResponse,
  ProblemDetails,
  RenamePlanPageRequest,
  RenamePlanSetRequest,
  ReorderPlanPagesRequest,
  ReorderPlanSetsRequest,
  SavePlanAnnotationsRequest,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const plansProcessPostV2 = (
  plansProcessUploadRequest: BodyType<PlansProcessUploadRequest>,
  params?: PlansProcessPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlansUploadResponse>(
    {
      url: `/apix/v2/Plans/process`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: plansProcessUploadRequest,
      params,
      signal,
    },
    options,
  );
};

export const getPlansProcessPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansProcessPostV2>>,
    TError,
    {
      data: BodyType<PlansProcessUploadRequest>;
      params?: PlansProcessPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansProcessPostV2>>,
  TError,
  {
    data: BodyType<PlansProcessUploadRequest>;
    params?: PlansProcessPostV2Params;
  },
  TContext
> => {
  const mutationKey = ["plansProcessPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansProcessPostV2>>,
    {
      data: BodyType<PlansProcessUploadRequest>;
      params?: PlansProcessPostV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return plansProcessPostV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansProcessPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansProcessPostV2>>
>;
export type PlansProcessPostV2MutationBody =
  BodyType<PlansProcessUploadRequest>;
export type PlansProcessPostV2MutationError = ErrorType<unknown>;

export const usePlansProcessPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansProcessPostV2>>,
    TError,
    {
      data: BodyType<PlansProcessUploadRequest>;
      params?: PlansProcessPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansProcessPostV2>>,
  TError,
  {
    data: BodyType<PlansProcessUploadRequest>;
    params?: PlansProcessPostV2Params;
  },
  TContext
> => {
  const mutationOptions = getPlansProcessPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable` 

 Superseded by v3, which accepts multiple documents for one set. Kept so clients that have not
refreshed to the multi-document frontend keep working through the deploy window.**Sunset Date**: 2026-11-01 - This endpoint is deprecated. Use POST /v3/Plans/revisions/process, which accepts multiple documents for one set.
 * @deprecated
 * @summary Starts a single-document revisions upload against an existing set. Splits the PDF, stages each
page, analyzes + matches them against the set, and produces a draft mapping the user reviews
before committing. Returns the background-job id to track via the progress popup; the draft id
is reported in the job's success payload.
 */
export const plansRevisionsProcessPostV2 = (
  plansProcessRevisionsUploadRequest: BodyType<PlansProcessRevisionsUploadRequest>,
  params?: PlansRevisionsProcessPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlansUploadResponse>(
    {
      url: `/apix/v2/Plans/revisions/process`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: plansProcessRevisionsUploadRequest,
      params,
      signal,
    },
    options,
  );
};

export const getPlansRevisionsProcessPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRevisionsProcessPostV2>>,
    TError,
    {
      data: BodyType<PlansProcessRevisionsUploadRequest>;
      params?: PlansRevisionsProcessPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansRevisionsProcessPostV2>>,
  TError,
  {
    data: BodyType<PlansProcessRevisionsUploadRequest>;
    params?: PlansRevisionsProcessPostV2Params;
  },
  TContext
> => {
  const mutationKey = ["plansRevisionsProcessPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansRevisionsProcessPostV2>>,
    {
      data: BodyType<PlansProcessRevisionsUploadRequest>;
      params?: PlansRevisionsProcessPostV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return plansRevisionsProcessPostV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansRevisionsProcessPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansRevisionsProcessPostV2>>
>;
export type PlansRevisionsProcessPostV2MutationBody =
  BodyType<PlansProcessRevisionsUploadRequest>;
export type PlansRevisionsProcessPostV2MutationError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary Starts a single-document revisions upload against an existing set. Splits the PDF, stages each
page, analyzes + matches them against the set, and produces a draft mapping the user reviews
before committing. Returns the background-job id to track via the progress popup; the draft id
is reported in the job's success payload.
 */
export const usePlansRevisionsProcessPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRevisionsProcessPostV2>>,
    TError,
    {
      data: BodyType<PlansProcessRevisionsUploadRequest>;
      params?: PlansRevisionsProcessPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansRevisionsProcessPostV2>>,
  TError,
  {
    data: BodyType<PlansProcessRevisionsUploadRequest>;
    params?: PlansRevisionsProcessPostV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getPlansRevisionsProcessPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Returns the proposed mapping for a revisions draft so the user can review and adjust it
before committing.
 */
export const plansRevisionsByDraftIdGetV2 = (
  draftId: string,
  params?: PlansRevisionsByDraftIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlanRevisionDraftResponse>(
    {
      url: `/apix/v2/Plans/revisions/${draftId}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getPlansRevisionsByDraftIdGetV2QueryKey = (
  draftId?: string,
  params?: PlansRevisionsByDraftIdGetV2Params,
) => {
  return [
    `/apix/v2/Plans/revisions/${draftId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlansRevisionsByDraftIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansRevisionsByDraftIdGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(
  draftId: string,
  params?: PlansRevisionsByDraftIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansRevisionsByDraftIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlansRevisionsByDraftIdGetV2QueryKey(draftId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansRevisionsByDraftIdGetV2>>
  > = ({ signal }) =>
    plansRevisionsByDraftIdGetV2(draftId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!draftId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansRevisionsByDraftIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansRevisionsByDraftIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansRevisionsByDraftIdGetV2>>
>;
export type PlansRevisionsByDraftIdGetV2QueryError = ErrorType<ProblemDetails>;

/**
 * @summary Returns the proposed mapping for a revisions draft so the user can review and adjust it
before committing.
 */

export function usePlansRevisionsByDraftIdGetV2<
  TData = Awaited<ReturnType<typeof plansRevisionsByDraftIdGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(
  draftId: string,
  params?: PlansRevisionsByDraftIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansRevisionsByDraftIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansRevisionsByDraftIdGetV2QueryOptions(
    draftId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Discards a pending revisions draft — deletes the draft and its staged page blobs without
applying anything to the set.
 */
export const plansRevisionsByDraftIdDeleteV2 = (
  draftId: string,
  params?: PlansRevisionsByDraftIdDeleteV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    { url: `/apix/v2/Plans/revisions/${draftId}`, method: "DELETE", params },
    options,
  );
};

export const getPlansRevisionsByDraftIdDeleteV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRevisionsByDraftIdDeleteV2>>,
    TError,
    { draftId: string; params?: PlansRevisionsByDraftIdDeleteV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansRevisionsByDraftIdDeleteV2>>,
  TError,
  { draftId: string; params?: PlansRevisionsByDraftIdDeleteV2Params },
  TContext
> => {
  const mutationKey = ["plansRevisionsByDraftIdDeleteV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansRevisionsByDraftIdDeleteV2>>,
    { draftId: string; params?: PlansRevisionsByDraftIdDeleteV2Params }
  > = (props) => {
    const { draftId, params } = props ?? {};

    return plansRevisionsByDraftIdDeleteV2(draftId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansRevisionsByDraftIdDeleteV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansRevisionsByDraftIdDeleteV2>>
>;

export type PlansRevisionsByDraftIdDeleteV2MutationError = ErrorType<unknown>;

/**
 * @summary Discards a pending revisions draft — deletes the draft and its staged page blobs without
applying anything to the set.
 */
export const usePlansRevisionsByDraftIdDeleteV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRevisionsByDraftIdDeleteV2>>,
    TError,
    { draftId: string; params?: PlansRevisionsByDraftIdDeleteV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansRevisionsByDraftIdDeleteV2>>,
  TError,
  { draftId: string; params?: PlansRevisionsByDraftIdDeleteV2Params },
  TContext
> => {
  const mutationOptions =
    getPlansRevisionsByDraftIdDeleteV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Streams a staged (not-yet-committed) incoming revision page so the review modal can preview it.
 */
export const plansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2 = (
  draftId: string,
  incomingPageId: string,
  params?: PlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Plans/revisions/${draftId}/page/${incomingPageId}/file`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getPlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2QueryKey =
  (
    draftId?: string,
    incomingPageId?: string,
    params?: PlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2Params,
  ) => {
    return [
      `/apix/v2/Plans/revisions/${draftId}/page/${incomingPageId}/file`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getPlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof plansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2>
    >,
    TError = ErrorType<ProblemDetails>,
  >(
    draftId: string,
    incomingPageId: string,
    params?: PlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2Params,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof plansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getPlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2QueryKey(
        draftId,
        incomingPageId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof plansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2>
      >
    > = ({ signal }) =>
      plansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2(
        draftId,
        incomingPageId,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(draftId && incomingPageId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof plansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type PlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof plansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2>
    >
  >;
export type PlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2QueryError =
  ErrorType<ProblemDetails>;

/**
 * @summary Streams a staged (not-yet-committed) incoming revision page so the review modal can preview it.
 */

export function usePlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2<
  TData = Awaited<
    ReturnType<typeof plansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2>
  >,
  TError = ErrorType<ProblemDetails>,
>(
  draftId: string,
  incomingPageId: string,
  params?: PlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof plansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getPlansRevisionsPageFileByDraftIdAndIncomingPageIdGetV2QueryOptions(
      draftId,
      incomingPageId,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Tells the Plans page whether the given set has a pending (unfinalized) revision import to
review, so it can surface the review banner.
 */
export const plansRevisionsActiveGetV2 = (
  params?: PlansRevisionsActiveGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlanRevisionActiveDraftResponse>(
    { url: `/apix/v2/Plans/revisions/active`, method: "GET", params, signal },
    options,
  );
};

export const getPlansRevisionsActiveGetV2QueryKey = (
  params?: PlansRevisionsActiveGetV2Params,
) => {
  return [
    `/apix/v2/Plans/revisions/active`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlansRevisionsActiveGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansRevisionsActiveGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: PlansRevisionsActiveGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansRevisionsActiveGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlansRevisionsActiveGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansRevisionsActiveGetV2>>
  > = ({ signal }) => plansRevisionsActiveGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof plansRevisionsActiveGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansRevisionsActiveGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansRevisionsActiveGetV2>>
>;
export type PlansRevisionsActiveGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Tells the Plans page whether the given set has a pending (unfinalized) revision import to
review, so it can surface the review banner.
 */

export function usePlansRevisionsActiveGetV2<
  TData = Awaited<ReturnType<typeof plansRevisionsActiveGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: PlansRevisionsActiveGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansRevisionsActiveGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansRevisionsActiveGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Commits a revisions draft using the user's confirmed mapping: matched pages are versioned,
new pages are appended, and the staged blobs + draft are cleaned up.
 */
export const plansRevisionsCommitByDraftIdPostV2 = (
  draftId: string,
  planRevisionCommitRequest: BodyType<PlanRevisionCommitRequest>,
  params?: PlansRevisionsCommitByDraftIdPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Plans/revisions/${draftId}/commit`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: planRevisionCommitRequest,
      params,
      signal,
    },
    options,
  );
};

export const getPlansRevisionsCommitByDraftIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRevisionsCommitByDraftIdPostV2>>,
    TError,
    {
      draftId: string;
      data: BodyType<PlanRevisionCommitRequest>;
      params?: PlansRevisionsCommitByDraftIdPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansRevisionsCommitByDraftIdPostV2>>,
  TError,
  {
    draftId: string;
    data: BodyType<PlanRevisionCommitRequest>;
    params?: PlansRevisionsCommitByDraftIdPostV2Params;
  },
  TContext
> => {
  const mutationKey = ["plansRevisionsCommitByDraftIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansRevisionsCommitByDraftIdPostV2>>,
    {
      draftId: string;
      data: BodyType<PlanRevisionCommitRequest>;
      params?: PlansRevisionsCommitByDraftIdPostV2Params;
    }
  > = (props) => {
    const { draftId, data, params } = props ?? {};

    return plansRevisionsCommitByDraftIdPostV2(
      draftId,
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansRevisionsCommitByDraftIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansRevisionsCommitByDraftIdPostV2>>
>;
export type PlansRevisionsCommitByDraftIdPostV2MutationBody =
  BodyType<PlanRevisionCommitRequest>;
export type PlansRevisionsCommitByDraftIdPostV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Commits a revisions draft using the user's confirmed mapping: matched pages are versioned,
new pages are appended, and the staged blobs + draft are cleaned up.
 */
export const usePlansRevisionsCommitByDraftIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRevisionsCommitByDraftIdPostV2>>,
    TError,
    {
      draftId: string;
      data: BodyType<PlanRevisionCommitRequest>;
      params?: PlansRevisionsCommitByDraftIdPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansRevisionsCommitByDraftIdPostV2>>,
  TError,
  {
    draftId: string;
    data: BodyType<PlanRevisionCommitRequest>;
    params?: PlansRevisionsCommitByDraftIdPostV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getPlansRevisionsCommitByDraftIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Sends the "New Plan Added" notification for a plan set independent of the original upload —
used by the first-time (empty-state) upload flow's persistent notify banner, since the
recipient choice there is made after the upload request has already completed.
 */
export const plansNotifyBySetIdPostV2 = (
  setId: string,
  plansNotifyRequest: BodyType<PlansNotifyRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Plans/${setId}/notify`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: plansNotifyRequest,
      signal,
    },
    options,
  );
};

export const getPlansNotifyBySetIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansNotifyBySetIdPostV2>>,
    TError,
    { setId: string; data: BodyType<PlansNotifyRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansNotifyBySetIdPostV2>>,
  TError,
  { setId: string; data: BodyType<PlansNotifyRequest> },
  TContext
> => {
  const mutationKey = ["plansNotifyBySetIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansNotifyBySetIdPostV2>>,
    { setId: string; data: BodyType<PlansNotifyRequest> }
  > = (props) => {
    const { setId, data } = props ?? {};

    return plansNotifyBySetIdPostV2(setId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansNotifyBySetIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansNotifyBySetIdPostV2>>
>;
export type PlansNotifyBySetIdPostV2MutationBody = BodyType<PlansNotifyRequest>;
export type PlansNotifyBySetIdPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Sends the "New Plan Added" notification for a plan set independent of the original upload —
used by the first-time (empty-state) upload flow's persistent notify banner, since the
recipient choice there is made after the upload request has already completed.
 */
export const usePlansNotifyBySetIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansNotifyBySetIdPostV2>>,
    TError,
    { setId: string; data: BodyType<PlansNotifyRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansNotifyBySetIdPostV2>>,
  TError,
  { setId: string; data: BodyType<PlansNotifyRequest> },
  TContext
> => {
  const mutationOptions = getPlansNotifyBySetIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const plansGetV2 = (
  params?: PlansGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlansGetResponse>(
    { url: `/apix/v2/Plans`, method: "GET", params, signal },
    options,
  );
};

export const getPlansGetV2QueryKey = (params?: PlansGetV2Params) => {
  return [`/apix/v2/Plans`, ...(params ? [params] : [])] as const;
};

export const getPlansGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: PlansGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlansGetV2QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof plansGetV2>>> = ({
    signal,
  }) => plansGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof plansGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansGetV2>>
>;
export type PlansGetV2QueryError = ErrorType<unknown>;

export function usePlansGetV2<
  TData = Awaited<ReturnType<typeof plansGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: PlansGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const plansSharePostV2 = (
  params?: PlansSharePostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlansShareResponse>(
    { url: `/apix/v2/Plans/share`, method: "POST", params, signal },
    options,
  );
};

export const getPlansSharePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansSharePostV2>>,
    TError,
    { params?: PlansSharePostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansSharePostV2>>,
  TError,
  { params?: PlansSharePostV2Params },
  TContext
> => {
  const mutationKey = ["plansSharePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansSharePostV2>>,
    { params?: PlansSharePostV2Params }
  > = (props) => {
    const { params } = props ?? {};

    return plansSharePostV2(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansSharePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansSharePostV2>>
>;

export type PlansSharePostV2MutationError = ErrorType<unknown>;

export const usePlansSharePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansSharePostV2>>,
    TError,
    { params?: PlansSharePostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansSharePostV2>>,
  TError,
  { params?: PlansSharePostV2Params },
  TContext
> => {
  const mutationOptions = getPlansSharePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Stability Level**: `stable`
 */
export const plansExternalByShareTokenGetV2 = (
  shareToken: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlansGetResponse>(
    { url: `/apix/v2/Plans/external/${shareToken}`, method: "GET", signal },
    options,
  );
};

export const getPlansExternalByShareTokenGetV2QueryKey = (
  shareToken?: string,
) => {
  return [`/apix/v2/Plans/external/${shareToken}`] as const;
};

export const getPlansExternalByShareTokenGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansExternalByShareTokenGetV2>>,
  TError = ErrorType<unknown>,
>(
  shareToken: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansExternalByShareTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlansExternalByShareTokenGetV2QueryKey(shareToken);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansExternalByShareTokenGetV2>>
  > = ({ signal }) =>
    plansExternalByShareTokenGetV2(shareToken, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shareToken,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansExternalByShareTokenGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansExternalByShareTokenGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansExternalByShareTokenGetV2>>
>;
export type PlansExternalByShareTokenGetV2QueryError = ErrorType<unknown>;

export function usePlansExternalByShareTokenGetV2<
  TData = Awaited<ReturnType<typeof plansExternalByShareTokenGetV2>>,
  TError = ErrorType<unknown>,
>(
  shareToken: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansExternalByShareTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansExternalByShareTokenGetV2QueryOptions(
    shareToken,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const plansByPageIdGetV2 = (
  pageId: string,
  params?: PlansByPageIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlansGetPageResponse>(
    { url: `/apix/v2/Plans/${pageId}`, method: "GET", params, signal },
    options,
  );
};

export const getPlansByPageIdGetV2QueryKey = (
  pageId?: string,
  params?: PlansByPageIdGetV2Params,
) => {
  return [`/apix/v2/Plans/${pageId}`, ...(params ? [params] : [])] as const;
};

export const getPlansByPageIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  params?: PlansByPageIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlansByPageIdGetV2QueryKey(pageId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansByPageIdGetV2>>
  > = ({ signal }) =>
    plansByPageIdGetV2(pageId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pageId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansByPageIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansByPageIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansByPageIdGetV2>>
>;
export type PlansByPageIdGetV2QueryError = ErrorType<unknown>;

export function usePlansByPageIdGetV2<
  TData = Awaited<ReturnType<typeof plansByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  params?: PlansByPageIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansByPageIdGetV2QueryOptions(
    pageId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Deletes a plan page
 */
export const plansByPageIdDeleteV2 = (
  pageId: string,
  params?: PlansByPageIdDeleteV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    { url: `/apix/v2/Plans/${pageId}`, method: "DELETE", params },
    options,
  );
};

export const getPlansByPageIdDeleteV2MutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansByPageIdDeleteV2>>,
    TError,
    { pageId: string; params?: PlansByPageIdDeleteV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansByPageIdDeleteV2>>,
  TError,
  { pageId: string; params?: PlansByPageIdDeleteV2Params },
  TContext
> => {
  const mutationKey = ["plansByPageIdDeleteV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansByPageIdDeleteV2>>,
    { pageId: string; params?: PlansByPageIdDeleteV2Params }
  > = (props) => {
    const { pageId, params } = props ?? {};

    return plansByPageIdDeleteV2(pageId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansByPageIdDeleteV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansByPageIdDeleteV2>>
>;

export type PlansByPageIdDeleteV2MutationError = ErrorType<ProblemDetails>;

/**
 * @summary Deletes a plan page
 */
export const usePlansByPageIdDeleteV2 = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansByPageIdDeleteV2>>,
    TError,
    { pageId: string; params?: PlansByPageIdDeleteV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansByPageIdDeleteV2>>,
  TError,
  { pageId: string; params?: PlansByPageIdDeleteV2Params },
  TContext
> => {
  const mutationOptions = getPlansByPageIdDeleteV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Stability Level**: `stable`
 */
export const plansExternalDetailsByPageIdGetV2 = (
  pageId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlansGetPageResponse>(
    { url: `/apix/v2/Plans/external-details/${pageId}`, method: "GET", signal },
    options,
  );
};

export const getPlansExternalDetailsByPageIdGetV2QueryKey = (
  pageId?: string,
) => {
  return [`/apix/v2/Plans/external-details/${pageId}`] as const;
};

export const getPlansExternalDetailsByPageIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansExternalDetailsByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansExternalDetailsByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlansExternalDetailsByPageIdGetV2QueryKey(pageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansExternalDetailsByPageIdGetV2>>
  > = ({ signal }) =>
    plansExternalDetailsByPageIdGetV2(pageId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pageId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansExternalDetailsByPageIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansExternalDetailsByPageIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansExternalDetailsByPageIdGetV2>>
>;
export type PlansExternalDetailsByPageIdGetV2QueryError = ErrorType<unknown>;

export function usePlansExternalDetailsByPageIdGetV2<
  TData = Awaited<ReturnType<typeof plansExternalDetailsByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansExternalDetailsByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansExternalDetailsByPageIdGetV2QueryOptions(
    pageId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets a plan page from MediaService. Optionally retrieves a specific version by GCP generation ID.
 */
export const plansFileByPageIdGetV2 = (
  pageId: string,
  params?: PlansFileByPageIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Plans/file/${pageId}`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getPlansFileByPageIdGetV2QueryKey = (
  pageId?: string,
  params?: PlansFileByPageIdGetV2Params,
) => {
  return [
    `/apix/v2/Plans/file/${pageId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlansFileByPageIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansFileByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  params?: PlansFileByPageIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansFileByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlansFileByPageIdGetV2QueryKey(pageId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansFileByPageIdGetV2>>
  > = ({ signal }) =>
    plansFileByPageIdGetV2(pageId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pageId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansFileByPageIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansFileByPageIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansFileByPageIdGetV2>>
>;
export type PlansFileByPageIdGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets a plan page from MediaService. Optionally retrieves a specific version by GCP generation ID.
 */

export function usePlansFileByPageIdGetV2<
  TData = Awaited<ReturnType<typeof plansFileByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  params?: PlansFileByPageIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansFileByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansFileByPageIdGetV2QueryOptions(
    pageId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets a plan thumbnail from MediaService
 */
export const plansThumbnailByPageIdAndRowVersionGetV2 = (
  pageId: string,
  rowVersion: string,
  params?: PlansThumbnailByPageIdAndRowVersionGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Plans/thumbnail/${pageId}/${rowVersion}`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getPlansThumbnailByPageIdAndRowVersionGetV2QueryKey = (
  pageId?: string,
  rowVersion?: string,
  params?: PlansThumbnailByPageIdAndRowVersionGetV2Params,
) => {
  return [
    `/apix/v2/Plans/thumbnail/${pageId}/${rowVersion}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlansThumbnailByPageIdAndRowVersionGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansThumbnailByPageIdAndRowVersionGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(
  pageId: string,
  rowVersion: string,
  params?: PlansThumbnailByPageIdAndRowVersionGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansThumbnailByPageIdAndRowVersionGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlansThumbnailByPageIdAndRowVersionGetV2QueryKey(
      pageId,
      rowVersion,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansThumbnailByPageIdAndRowVersionGetV2>>
  > = ({ signal }) =>
    plansThumbnailByPageIdAndRowVersionGetV2(
      pageId,
      rowVersion,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(pageId && rowVersion),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansThumbnailByPageIdAndRowVersionGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansThumbnailByPageIdAndRowVersionGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansThumbnailByPageIdAndRowVersionGetV2>>
>;
export type PlansThumbnailByPageIdAndRowVersionGetV2QueryError =
  ErrorType<ProblemDetails>;

/**
 * @summary Gets a plan thumbnail from MediaService
 */

export function usePlansThumbnailByPageIdAndRowVersionGetV2<
  TData = Awaited<ReturnType<typeof plansThumbnailByPageIdAndRowVersionGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(
  pageId: string,
  rowVersion: string,
  params?: PlansThumbnailByPageIdAndRowVersionGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansThumbnailByPageIdAndRowVersionGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansThumbnailByPageIdAndRowVersionGetV2QueryOptions(
    pageId,
    rowVersion,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Deletes a plan category (set) and all associated pages
 */
export const plansSetBySetIdDeleteV2 = (
  setId: string,
  params?: PlansSetBySetIdDeleteV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    { url: `/apix/v2/Plans/set/${setId}`, method: "DELETE", params },
    options,
  );
};

export const getPlansSetBySetIdDeleteV2MutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansSetBySetIdDeleteV2>>,
    TError,
    { setId: string; params?: PlansSetBySetIdDeleteV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansSetBySetIdDeleteV2>>,
  TError,
  { setId: string; params?: PlansSetBySetIdDeleteV2Params },
  TContext
> => {
  const mutationKey = ["plansSetBySetIdDeleteV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansSetBySetIdDeleteV2>>,
    { setId: string; params?: PlansSetBySetIdDeleteV2Params }
  > = (props) => {
    const { setId, params } = props ?? {};

    return plansSetBySetIdDeleteV2(setId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansSetBySetIdDeleteV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansSetBySetIdDeleteV2>>
>;

export type PlansSetBySetIdDeleteV2MutationError = ErrorType<ProblemDetails>;

/**
 * @summary Deletes a plan category (set) and all associated pages
 */
export const usePlansSetBySetIdDeleteV2 = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansSetBySetIdDeleteV2>>,
    TError,
    { setId: string; params?: PlansSetBySetIdDeleteV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansSetBySetIdDeleteV2>>,
  TError,
  { setId: string; params?: PlansSetBySetIdDeleteV2Params },
  TContext
> => {
  const mutationOptions = getPlansSetBySetIdDeleteV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Stability Level**: `stable`
 * @summary Gets a plan page from MediaService
 */
export const plansExternalFileByPageIdGetV2 = (
  pageId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Plans/external-file/${pageId}`,
      method: "GET",
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getPlansExternalFileByPageIdGetV2QueryKey = (pageId?: string) => {
  return [`/apix/v2/Plans/external-file/${pageId}`] as const;
};

export const getPlansExternalFileByPageIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansExternalFileByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansExternalFileByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlansExternalFileByPageIdGetV2QueryKey(pageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansExternalFileByPageIdGetV2>>
  > = ({ signal }) =>
    plansExternalFileByPageIdGetV2(pageId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pageId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansExternalFileByPageIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansExternalFileByPageIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansExternalFileByPageIdGetV2>>
>;
export type PlansExternalFileByPageIdGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets a plan page from MediaService
 */

export function usePlansExternalFileByPageIdGetV2<
  TData = Awaited<ReturnType<typeof plansExternalFileByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansExternalFileByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansExternalFileByPageIdGetV2QueryOptions(
    pageId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 * @summary Gets a plan thumbnail from MediaService (external/anonymous access)
 */
export const plansExternalThumbnailByPageIdAndRowVersionGetV2 = (
  pageId: string,
  rowVersion: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Plans/external-thumbnail/${pageId}/${rowVersion}`,
      method: "GET",
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getPlansExternalThumbnailByPageIdAndRowVersionGetV2QueryKey = (
  pageId?: string,
  rowVersion?: string,
) => {
  return [`/apix/v2/Plans/external-thumbnail/${pageId}/${rowVersion}`] as const;
};

export const getPlansExternalThumbnailByPageIdAndRowVersionGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof plansExternalThumbnailByPageIdAndRowVersionGetV2>
  >,
  TError = ErrorType<ProblemDetails>,
>(
  pageId: string,
  rowVersion: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof plansExternalThumbnailByPageIdAndRowVersionGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlansExternalThumbnailByPageIdAndRowVersionGetV2QueryKey(
      pageId,
      rowVersion,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansExternalThumbnailByPageIdAndRowVersionGetV2>>
  > = ({ signal }) =>
    plansExternalThumbnailByPageIdAndRowVersionGetV2(
      pageId,
      rowVersion,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(pageId && rowVersion),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof plansExternalThumbnailByPageIdAndRowVersionGetV2>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansExternalThumbnailByPageIdAndRowVersionGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof plansExternalThumbnailByPageIdAndRowVersionGetV2>>
  >;
export type PlansExternalThumbnailByPageIdAndRowVersionGetV2QueryError =
  ErrorType<ProblemDetails>;

/**
 * @summary Gets a plan thumbnail from MediaService (external/anonymous access)
 */

export function usePlansExternalThumbnailByPageIdAndRowVersionGetV2<
  TData = Awaited<
    ReturnType<typeof plansExternalThumbnailByPageIdAndRowVersionGetV2>
  >,
  TError = ErrorType<ProblemDetails>,
>(
  pageId: string,
  rowVersion: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof plansExternalThumbnailByPageIdAndRowVersionGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getPlansExternalThumbnailByPageIdAndRowVersionGetV2QueryOptions(
      pageId,
      rowVersion,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Renames a plan set
 */
export const plansRenameSetPutV2 = (
  renamePlanSetRequest: BodyType<RenamePlanSetRequest>,
  params?: PlansRenameSetPutV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Plans/rename-set`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: renamePlanSetRequest,
      params,
    },
    options,
  );
};

export const getPlansRenameSetPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRenameSetPutV2>>,
    TError,
    {
      data: BodyType<RenamePlanSetRequest>;
      params?: PlansRenameSetPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansRenameSetPutV2>>,
  TError,
  { data: BodyType<RenamePlanSetRequest>; params?: PlansRenameSetPutV2Params },
  TContext
> => {
  const mutationKey = ["plansRenameSetPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansRenameSetPutV2>>,
    { data: BodyType<RenamePlanSetRequest>; params?: PlansRenameSetPutV2Params }
  > = (props) => {
    const { data, params } = props ?? {};

    return plansRenameSetPutV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansRenameSetPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansRenameSetPutV2>>
>;
export type PlansRenameSetPutV2MutationBody = BodyType<RenamePlanSetRequest>;
export type PlansRenameSetPutV2MutationError = ErrorType<unknown>;

/**
 * @summary Renames a plan set
 */
export const usePlansRenameSetPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRenameSetPutV2>>,
    TError,
    {
      data: BodyType<RenamePlanSetRequest>;
      params?: PlansRenameSetPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansRenameSetPutV2>>,
  TError,
  { data: BodyType<RenamePlanSetRequest>; params?: PlansRenameSetPutV2Params },
  TContext
> => {
  const mutationOptions = getPlansRenameSetPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Renames a plan page
 */
export const plansRenamePagePutV2 = (
  renamePlanPageRequest: BodyType<RenamePlanPageRequest>,
  params?: PlansRenamePagePutV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Plans/rename-page`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: renamePlanPageRequest,
      params,
    },
    options,
  );
};

export const getPlansRenamePagePutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRenamePagePutV2>>,
    TError,
    {
      data: BodyType<RenamePlanPageRequest>;
      params?: PlansRenamePagePutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansRenamePagePutV2>>,
  TError,
  {
    data: BodyType<RenamePlanPageRequest>;
    params?: PlansRenamePagePutV2Params;
  },
  TContext
> => {
  const mutationKey = ["plansRenamePagePutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansRenamePagePutV2>>,
    {
      data: BodyType<RenamePlanPageRequest>;
      params?: PlansRenamePagePutV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return plansRenamePagePutV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansRenamePagePutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansRenamePagePutV2>>
>;
export type PlansRenamePagePutV2MutationBody = BodyType<RenamePlanPageRequest>;
export type PlansRenamePagePutV2MutationError = ErrorType<unknown>;

/**
 * @summary Renames a plan page
 */
export const usePlansRenamePagePutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRenamePagePutV2>>,
    TError,
    {
      data: BodyType<RenamePlanPageRequest>;
      params?: PlansRenamePagePutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansRenamePagePutV2>>,
  TError,
  {
    data: BodyType<RenamePlanPageRequest>;
    params?: PlansRenamePagePutV2Params;
  },
  TContext
> => {
  const mutationOptions = getPlansRenamePagePutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Uploads a new version of an existing plan page
 */
export const plansVersionByPageIdPostV2 = (
  pageId: string,
  plansVersionByPageIdPostV2Body: BodyType<PlansVersionByPageIdPostV2Body>,
  params?: PlansVersionByPageIdPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (plansVersionByPageIdPostV2Body.File !== undefined) {
    formData.append(`File`, plansVersionByPageIdPostV2Body.File);
  }

  return apixHandler<void>(
    {
      url: `/apix/v2/Plans/${pageId}/version`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      params,
      signal,
    },
    options,
  );
};

export const getPlansVersionByPageIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansVersionByPageIdPostV2>>,
    TError,
    {
      pageId: string;
      data: BodyType<PlansVersionByPageIdPostV2Body>;
      params?: PlansVersionByPageIdPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansVersionByPageIdPostV2>>,
  TError,
  {
    pageId: string;
    data: BodyType<PlansVersionByPageIdPostV2Body>;
    params?: PlansVersionByPageIdPostV2Params;
  },
  TContext
> => {
  const mutationKey = ["plansVersionByPageIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansVersionByPageIdPostV2>>,
    {
      pageId: string;
      data: BodyType<PlansVersionByPageIdPostV2Body>;
      params?: PlansVersionByPageIdPostV2Params;
    }
  > = (props) => {
    const { pageId, data, params } = props ?? {};

    return plansVersionByPageIdPostV2(pageId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansVersionByPageIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansVersionByPageIdPostV2>>
>;
export type PlansVersionByPageIdPostV2MutationBody =
  BodyType<PlansVersionByPageIdPostV2Body>;
export type PlansVersionByPageIdPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Uploads a new version of an existing plan page
 */
export const usePlansVersionByPageIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansVersionByPageIdPostV2>>,
    TError,
    {
      pageId: string;
      data: BodyType<PlansVersionByPageIdPostV2Body>;
      params?: PlansVersionByPageIdPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansVersionByPageIdPostV2>>,
  TError,
  {
    pageId: string;
    data: BodyType<PlansVersionByPageIdPostV2Body>;
    params?: PlansVersionByPageIdPostV2Params;
  },
  TContext
> => {
  const mutationOptions = getPlansVersionByPageIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets the version history for a plan page
 */
export const plansHistoryByPageIdGetV2 = (
  pageId: string,
  params?: PlansHistoryByPageIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlanVersionHistoryResponse>(
    { url: `/apix/v2/Plans/${pageId}/history`, method: "GET", params, signal },
    options,
  );
};

export const getPlansHistoryByPageIdGetV2QueryKey = (
  pageId?: string,
  params?: PlansHistoryByPageIdGetV2Params,
) => {
  return [
    `/apix/v2/Plans/${pageId}/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlansHistoryByPageIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansHistoryByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  params?: PlansHistoryByPageIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansHistoryByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlansHistoryByPageIdGetV2QueryKey(pageId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansHistoryByPageIdGetV2>>
  > = ({ signal }) =>
    plansHistoryByPageIdGetV2(pageId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pageId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansHistoryByPageIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansHistoryByPageIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansHistoryByPageIdGetV2>>
>;
export type PlansHistoryByPageIdGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets the version history for a plan page
 */

export function usePlansHistoryByPageIdGetV2<
  TData = Awaited<ReturnType<typeof plansHistoryByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  params?: PlansHistoryByPageIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansHistoryByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansHistoryByPageIdGetV2QueryOptions(
    pageId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Reorders plan pages within a set
 */
export const plansReorderPagesPutV2 = (
  reorderPlanPagesRequest: BodyType<ReorderPlanPagesRequest>,
  params?: PlansReorderPagesPutV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Plans/reorder-pages`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: reorderPlanPagesRequest,
      params,
    },
    options,
  );
};

export const getPlansReorderPagesPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansReorderPagesPutV2>>,
    TError,
    {
      data: BodyType<ReorderPlanPagesRequest>;
      params?: PlansReorderPagesPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansReorderPagesPutV2>>,
  TError,
  {
    data: BodyType<ReorderPlanPagesRequest>;
    params?: PlansReorderPagesPutV2Params;
  },
  TContext
> => {
  const mutationKey = ["plansReorderPagesPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansReorderPagesPutV2>>,
    {
      data: BodyType<ReorderPlanPagesRequest>;
      params?: PlansReorderPagesPutV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return plansReorderPagesPutV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansReorderPagesPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansReorderPagesPutV2>>
>;
export type PlansReorderPagesPutV2MutationBody =
  BodyType<ReorderPlanPagesRequest>;
export type PlansReorderPagesPutV2MutationError = ErrorType<unknown>;

/**
 * @summary Reorders plan pages within a set
 */
export const usePlansReorderPagesPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansReorderPagesPutV2>>,
    TError,
    {
      data: BodyType<ReorderPlanPagesRequest>;
      params?: PlansReorderPagesPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansReorderPagesPutV2>>,
  TError,
  {
    data: BodyType<ReorderPlanPagesRequest>;
    params?: PlansReorderPagesPutV2Params;
  },
  TContext
> => {
  const mutationOptions = getPlansReorderPagesPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Reorders plan sets within a job
 */
export const plansReorderSetsPutV2 = (
  reorderPlanSetsRequest: BodyType<ReorderPlanSetsRequest>,
  params?: PlansReorderSetsPutV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Plans/reorder-sets`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: reorderPlanSetsRequest,
      params,
    },
    options,
  );
};

export const getPlansReorderSetsPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansReorderSetsPutV2>>,
    TError,
    {
      data: BodyType<ReorderPlanSetsRequest>;
      params?: PlansReorderSetsPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansReorderSetsPutV2>>,
  TError,
  {
    data: BodyType<ReorderPlanSetsRequest>;
    params?: PlansReorderSetsPutV2Params;
  },
  TContext
> => {
  const mutationKey = ["plansReorderSetsPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansReorderSetsPutV2>>,
    {
      data: BodyType<ReorderPlanSetsRequest>;
      params?: PlansReorderSetsPutV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return plansReorderSetsPutV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansReorderSetsPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansReorderSetsPutV2>>
>;
export type PlansReorderSetsPutV2MutationBody =
  BodyType<ReorderPlanSetsRequest>;
export type PlansReorderSetsPutV2MutationError = ErrorType<unknown>;

/**
 * @summary Reorders plan sets within a job
 */
export const usePlansReorderSetsPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansReorderSetsPutV2>>,
    TError,
    {
      data: BodyType<ReorderPlanSetsRequest>;
      params?: PlansReorderSetsPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansReorderSetsPutV2>>,
  TError,
  {
    data: BodyType<ReorderPlanSetsRequest>;
    params?: PlansReorderSetsPutV2Params;
  },
  TContext
> => {
  const mutationOptions = getPlansReorderSetsPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const plansAnnotationsByPageIdGetV2 = (
  pageId: string,
  params?: PlansAnnotationsByPageIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlanAnnotationsResponse | void>(
    {
      url: `/apix/v2/Plans/${pageId}/annotations`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getPlansAnnotationsByPageIdGetV2QueryKey = (
  pageId?: string,
  params?: PlansAnnotationsByPageIdGetV2Params,
) => {
  return [
    `/apix/v2/Plans/${pageId}/annotations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlansAnnotationsByPageIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansAnnotationsByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  params?: PlansAnnotationsByPageIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansAnnotationsByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlansAnnotationsByPageIdGetV2QueryKey(pageId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansAnnotationsByPageIdGetV2>>
  > = ({ signal }) =>
    plansAnnotationsByPageIdGetV2(pageId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pageId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansAnnotationsByPageIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansAnnotationsByPageIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansAnnotationsByPageIdGetV2>>
>;
export type PlansAnnotationsByPageIdGetV2QueryError = ErrorType<unknown>;

export function usePlansAnnotationsByPageIdGetV2<
  TData = Awaited<ReturnType<typeof plansAnnotationsByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  params?: PlansAnnotationsByPageIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansAnnotationsByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansAnnotationsByPageIdGetV2QueryOptions(
    pageId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const plansAnnotationsByPageIdPutV2 = (
  pageId: string,
  savePlanAnnotationsRequest: BodyType<SavePlanAnnotationsRequest>,
  params?: PlansAnnotationsByPageIdPutV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Plans/${pageId}/annotations`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: savePlanAnnotationsRequest,
      params,
    },
    options,
  );
};

export const getPlansAnnotationsByPageIdPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansAnnotationsByPageIdPutV2>>,
    TError,
    {
      pageId: string;
      data: BodyType<SavePlanAnnotationsRequest>;
      params?: PlansAnnotationsByPageIdPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansAnnotationsByPageIdPutV2>>,
  TError,
  {
    pageId: string;
    data: BodyType<SavePlanAnnotationsRequest>;
    params?: PlansAnnotationsByPageIdPutV2Params;
  },
  TContext
> => {
  const mutationKey = ["plansAnnotationsByPageIdPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansAnnotationsByPageIdPutV2>>,
    {
      pageId: string;
      data: BodyType<SavePlanAnnotationsRequest>;
      params?: PlansAnnotationsByPageIdPutV2Params;
    }
  > = (props) => {
    const { pageId, data, params } = props ?? {};

    return plansAnnotationsByPageIdPutV2(pageId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansAnnotationsByPageIdPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansAnnotationsByPageIdPutV2>>
>;
export type PlansAnnotationsByPageIdPutV2MutationBody =
  BodyType<SavePlanAnnotationsRequest>;
export type PlansAnnotationsByPageIdPutV2MutationError = ErrorType<unknown>;

export const usePlansAnnotationsByPageIdPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansAnnotationsByPageIdPutV2>>,
    TError,
    {
      pageId: string;
      data: BodyType<SavePlanAnnotationsRequest>;
      params?: PlansAnnotationsByPageIdPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansAnnotationsByPageIdPutV2>>,
  TError,
  {
    pageId: string;
    data: BodyType<SavePlanAnnotationsRequest>;
    params?: PlansAnnotationsByPageIdPutV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getPlansAnnotationsByPageIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Stability Level**: `stable`
 */
export const plansExternalAnnotationsByPageIdGetV2 = (
  pageId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlanAnnotationsResponse | void>(
    {
      url: `/apix/v2/Plans/external-annotations/${pageId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getPlansExternalAnnotationsByPageIdGetV2QueryKey = (
  pageId?: string,
) => {
  return [`/apix/v2/Plans/external-annotations/${pageId}`] as const;
};

export const getPlansExternalAnnotationsByPageIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansExternalAnnotationsByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansExternalAnnotationsByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlansExternalAnnotationsByPageIdGetV2QueryKey(pageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansExternalAnnotationsByPageIdGetV2>>
  > = ({ signal }) =>
    plansExternalAnnotationsByPageIdGetV2(pageId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pageId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansExternalAnnotationsByPageIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansExternalAnnotationsByPageIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansExternalAnnotationsByPageIdGetV2>>
>;
export type PlansExternalAnnotationsByPageIdGetV2QueryError =
  ErrorType<unknown>;

export function usePlansExternalAnnotationsByPageIdGetV2<
  TData = Awaited<ReturnType<typeof plansExternalAnnotationsByPageIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  pageId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansExternalAnnotationsByPageIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansExternalAnnotationsByPageIdGetV2QueryOptions(
    pageId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Requests a download of the merged plan set. Cache hits return the proxy download
URL directly; misses enqueue a background merge — internal callers receive a
ProcessId and track progress via the background-job popup, external callers
receive the URL and HEAD-poll until the file is ready.
 */
export const plansDownloadSetBySetIdPostV2 = (
  setId: string,
  params?: PlansDownloadSetBySetIdPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlanSetDownloadResponse>(
    {
      url: `/apix/v2/Plans/${setId}/download-set`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getPlansDownloadSetBySetIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansDownloadSetBySetIdPostV2>>,
    TError,
    { setId: string; params?: PlansDownloadSetBySetIdPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansDownloadSetBySetIdPostV2>>,
  TError,
  { setId: string; params?: PlansDownloadSetBySetIdPostV2Params },
  TContext
> => {
  const mutationKey = ["plansDownloadSetBySetIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansDownloadSetBySetIdPostV2>>,
    { setId: string; params?: PlansDownloadSetBySetIdPostV2Params }
  > = (props) => {
    const { setId, params } = props ?? {};

    return plansDownloadSetBySetIdPostV2(setId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansDownloadSetBySetIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansDownloadSetBySetIdPostV2>>
>;

export type PlansDownloadSetBySetIdPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Requests a download of the merged plan set. Cache hits return the proxy download
URL directly; misses enqueue a background merge — internal callers receive a
ProcessId and track progress via the background-job popup, external callers
receive the URL and HEAD-poll until the file is ready.
 */
export const usePlansDownloadSetBySetIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansDownloadSetBySetIdPostV2>>,
    TError,
    { setId: string; params?: PlansDownloadSetBySetIdPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansDownloadSetBySetIdPostV2>>,
  TError,
  { setId: string; params?: PlansDownloadSetBySetIdPostV2Params },
  TContext
> => {
  const mutationOptions =
    getPlansDownloadSetBySetIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Stability Level**: `stable`
 * @summary Anonymous variant: requests a plan-set download. Mirrors the existing external plans
pattern — knowing the setId guid is the access boundary, no share-token validation.
 */
export const plansExternalSetsDownloadSetBySetIdPostV2 = (
  setId: string,
  params?: PlansExternalSetsDownloadSetBySetIdPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlanSetDownloadResponse>(
    {
      url: `/apix/v2/Plans/external/sets/${setId}/download-set`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getPlansExternalSetsDownloadSetBySetIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansExternalSetsDownloadSetBySetIdPostV2>>,
    TError,
    { setId: string; params?: PlansExternalSetsDownloadSetBySetIdPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansExternalSetsDownloadSetBySetIdPostV2>>,
  TError,
  { setId: string; params?: PlansExternalSetsDownloadSetBySetIdPostV2Params },
  TContext
> => {
  const mutationKey = ["plansExternalSetsDownloadSetBySetIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansExternalSetsDownloadSetBySetIdPostV2>>,
    { setId: string; params?: PlansExternalSetsDownloadSetBySetIdPostV2Params }
  > = (props) => {
    const { setId, params } = props ?? {};

    return plansExternalSetsDownloadSetBySetIdPostV2(
      setId,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansExternalSetsDownloadSetBySetIdPostV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof plansExternalSetsDownloadSetBySetIdPostV2>>
  >;

export type PlansExternalSetsDownloadSetBySetIdPostV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Anonymous variant: requests a plan-set download. Mirrors the existing external plans
pattern — knowing the setId guid is the access boundary, no share-token validation.
 */
export const usePlansExternalSetsDownloadSetBySetIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansExternalSetsDownloadSetBySetIdPostV2>>,
    TError,
    { setId: string; params?: PlansExternalSetsDownloadSetBySetIdPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansExternalSetsDownloadSetBySetIdPostV2>>,
  TError,
  { setId: string; params?: PlansExternalSetsDownloadSetBySetIdPostV2Params },
  TContext
> => {
  const mutationOptions =
    getPlansExternalSetsDownloadSetBySetIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Streams the cached merged PDF for a (setId, hash) pair. The internal flow
only hits this endpoint via the browser anchor download — the popup-driven
auto-trigger only fires after the worker writes Success, so the file is
guaranteed to be in GCS by the time the anchor is clicked. No HEAD-poll
needed (unlike the external route).
 */
export const plansDownloadSetFileBySetIdAndHashGetV2 = (
  setId: string,
  hash: string,
  params?: PlansDownloadSetFileBySetIdAndHashGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Plans/download-set/file/${setId}/${hash}`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getPlansDownloadSetFileBySetIdAndHashGetV2QueryKey = (
  setId?: string,
  hash?: string,
  params?: PlansDownloadSetFileBySetIdAndHashGetV2Params,
) => {
  return [
    `/apix/v2/Plans/download-set/file/${setId}/${hash}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlansDownloadSetFileBySetIdAndHashGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof plansDownloadSetFileBySetIdAndHashGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(
  setId: string,
  hash: string,
  params?: PlansDownloadSetFileBySetIdAndHashGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansDownloadSetFileBySetIdAndHashGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlansDownloadSetFileBySetIdAndHashGetV2QueryKey(setId, hash, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansDownloadSetFileBySetIdAndHashGetV2>>
  > = ({ signal }) =>
    plansDownloadSetFileBySetIdAndHashGetV2(
      setId,
      hash,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(setId && hash),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansDownloadSetFileBySetIdAndHashGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansDownloadSetFileBySetIdAndHashGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansDownloadSetFileBySetIdAndHashGetV2>>
>;
export type PlansDownloadSetFileBySetIdAndHashGetV2QueryError =
  ErrorType<ProblemDetails>;

/**
 * @summary Streams the cached merged PDF for a (setId, hash) pair. The internal flow
only hits this endpoint via the browser anchor download — the popup-driven
auto-trigger only fires after the worker writes Success, so the file is
guaranteed to be in GCS by the time the anchor is clicked. No HEAD-poll
needed (unlike the external route).
 */

export function usePlansDownloadSetFileBySetIdAndHashGetV2<
  TData = Awaited<ReturnType<typeof plansDownloadSetFileBySetIdAndHashGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(
  setId: string,
  hash: string,
  params?: PlansDownloadSetFileBySetIdAndHashGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansDownloadSetFileBySetIdAndHashGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansDownloadSetFileBySetIdAndHashGetV2QueryOptions(
    setId,
    hash,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 * @summary Anonymous variant: streams the cached merged PDF. The setId guid is the access
boundary — same pattern as /external-file/{pageId}. HEAD supported for polling.
 */
export const plansExternalSetsDownloadSetFileBySetIdAndHashGetV2 = (
  setId: string,
  hash: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Plans/external/sets/${setId}/download-set/file/${hash}`,
      method: "GET",
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getPlansExternalSetsDownloadSetFileBySetIdAndHashGetV2QueryKey = (
  setId?: string,
  hash?: string,
) => {
  return [
    `/apix/v2/Plans/external/sets/${setId}/download-set/file/${hash}`,
  ] as const;
};

export const getPlansExternalSetsDownloadSetFileBySetIdAndHashGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashGetV2>
    >,
    TError = ErrorType<ProblemDetails>,
  >(
    setId: string,
    hash: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashGetV2>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getPlansExternalSetsDownloadSetFileBySetIdAndHashGetV2QueryKey(
        setId,
        hash,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashGetV2>
      >
    > = ({ signal }) =>
      plansExternalSetsDownloadSetFileBySetIdAndHashGetV2(
        setId,
        hash,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(setId && hash),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashGetV2>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type PlansExternalSetsDownloadSetFileBySetIdAndHashGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashGetV2>
    >
  >;
export type PlansExternalSetsDownloadSetFileBySetIdAndHashGetV2QueryError =
  ErrorType<ProblemDetails>;

/**
 * @summary Anonymous variant: streams the cached merged PDF. The setId guid is the access
boundary — same pattern as /external-file/{pageId}. HEAD supported for polling.
 */

export function usePlansExternalSetsDownloadSetFileBySetIdAndHashGetV2<
  TData = Awaited<
    ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashGetV2>
  >,
  TError = ErrorType<ProblemDetails>,
>(
  setId: string,
  hash: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getPlansExternalSetsDownloadSetFileBySetIdAndHashGetV2QueryOptions(
      setId,
      hash,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 * @summary Anonymous variant: streams the cached merged PDF. The setId guid is the access
boundary — same pattern as /external-file/{pageId}. HEAD supported for polling.
 */
export const plansExternalSetsDownloadSetFileBySetIdAndHashHeadV2 = (
  setId: string,
  hash: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Plans/external/sets/${setId}/download-set/file/${hash}`,
      method: "HEAD",
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getPlansExternalSetsDownloadSetFileBySetIdAndHashHeadV2MutationOptions =
  <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashHeadV2>
      >,
      TError,
      { setId: string; hash: string },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashHeadV2>
    >,
    TError,
    { setId: string; hash: string },
    TContext
  > => {
    const mutationKey = [
      "plansExternalSetsDownloadSetFileBySetIdAndHashHeadV2",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashHeadV2>
      >,
      { setId: string; hash: string }
    > = (props) => {
      const { setId, hash } = props ?? {};

      return plansExternalSetsDownloadSetFileBySetIdAndHashHeadV2(
        setId,
        hash,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PlansExternalSetsDownloadSetFileBySetIdAndHashHeadV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashHeadV2>
    >
  >;

export type PlansExternalSetsDownloadSetFileBySetIdAndHashHeadV2MutationError =
  ErrorType<ProblemDetails>;

/**
 * @summary Anonymous variant: streams the cached merged PDF. The setId guid is the access
boundary — same pattern as /external-file/{pageId}. HEAD supported for polling.
 */
export const usePlansExternalSetsDownloadSetFileBySetIdAndHashHeadV2 = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashHeadV2>
    >,
    TError,
    { setId: string; hash: string },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof plansExternalSetsDownloadSetFileBySetIdAndHashHeadV2>
  >,
  TError,
  { setId: string; hash: string },
  TContext
> => {
  const mutationOptions =
    getPlansExternalSetsDownloadSetFileBySetIdAndHashHeadV2MutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Starts a mass-revisions upload against an existing set from one or more documents. Splits each
PDF, stages every page, analyzes + matches them against the set, and produces a single draft
mapping the user reviews before committing. Returns the background-job id to track via the
progress popup; the draft id is reported in the job's success payload.
 */
export const plansRevisionsProcessPostV3 = (
  plansProcessRevisionsUploadRequestV3: BodyType<PlansProcessRevisionsUploadRequestV3>,
  params?: PlansRevisionsProcessPostV3Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlansUploadResponse>(
    {
      url: `/apix/v3/Plans/revisions/process`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: plansProcessRevisionsUploadRequestV3,
      params,
      signal,
    },
    options,
  );
};

export const getPlansRevisionsProcessPostV3MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRevisionsProcessPostV3>>,
    TError,
    {
      data: BodyType<PlansProcessRevisionsUploadRequestV3>;
      params?: PlansRevisionsProcessPostV3Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plansRevisionsProcessPostV3>>,
  TError,
  {
    data: BodyType<PlansProcessRevisionsUploadRequestV3>;
    params?: PlansRevisionsProcessPostV3Params;
  },
  TContext
> => {
  const mutationKey = ["plansRevisionsProcessPostV3"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plansRevisionsProcessPostV3>>,
    {
      data: BodyType<PlansProcessRevisionsUploadRequestV3>;
      params?: PlansRevisionsProcessPostV3Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return plansRevisionsProcessPostV3(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlansRevisionsProcessPostV3MutationResult = NonNullable<
  Awaited<ReturnType<typeof plansRevisionsProcessPostV3>>
>;
export type PlansRevisionsProcessPostV3MutationBody =
  BodyType<PlansProcessRevisionsUploadRequestV3>;
export type PlansRevisionsProcessPostV3MutationError = ErrorType<unknown>;

/**
 * @summary Starts a mass-revisions upload against an existing set from one or more documents. Splits each
PDF, stages every page, analyzes + matches them against the set, and produces a single draft
mapping the user reviews before committing. Returns the background-job id to track via the
progress popup; the draft id is reported in the job's success payload.
 */
export const usePlansRevisionsProcessPostV3 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plansRevisionsProcessPostV3>>,
    TError,
    {
      data: BodyType<PlansProcessRevisionsUploadRequestV3>;
      params?: PlansRevisionsProcessPostV3Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plansRevisionsProcessPostV3>>,
  TError,
  {
    data: BodyType<PlansProcessRevisionsUploadRequestV3>;
    params?: PlansRevisionsProcessPostV3Params;
  },
  TContext
> => {
  const mutationOptions =
    getPlansRevisionsProcessPostV3MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const plansBySetIdGetV3 = (
  setId: string,
  params?: PlansBySetIdGetV3Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlansGetPageResponse>(
    { url: `/apix/v3/Plans/${setId}`, method: "GET", params, signal },
    options,
  );
};

export const getPlansBySetIdGetV3QueryKey = (
  setId?: string,
  params?: PlansBySetIdGetV3Params,
) => {
  return [`/apix/v3/Plans/${setId}`, ...(params ? [params] : [])] as const;
};

export const getPlansBySetIdGetV3QueryOptions = <
  TData = Awaited<ReturnType<typeof plansBySetIdGetV3>>,
  TError = ErrorType<unknown>,
>(
  setId: string,
  params?: PlansBySetIdGetV3Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansBySetIdGetV3>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlansBySetIdGetV3QueryKey(setId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansBySetIdGetV3>>
  > = ({ signal }) => plansBySetIdGetV3(setId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!setId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansBySetIdGetV3>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansBySetIdGetV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansBySetIdGetV3>>
>;
export type PlansBySetIdGetV3QueryError = ErrorType<unknown>;

export function usePlansBySetIdGetV3<
  TData = Awaited<ReturnType<typeof plansBySetIdGetV3>>,
  TError = ErrorType<unknown>,
>(
  setId: string,
  params?: PlansBySetIdGetV3Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansBySetIdGetV3>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansBySetIdGetV3QueryOptions(setId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 */
export const plansExternalDetailsBySetIdGetV3 = (
  setId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<PlansGetPageResponse>(
    { url: `/apix/v3/Plans/external-details/${setId}`, method: "GET", signal },
    options,
  );
};

export const getPlansExternalDetailsBySetIdGetV3QueryKey = (setId?: string) => {
  return [`/apix/v3/Plans/external-details/${setId}`] as const;
};

export const getPlansExternalDetailsBySetIdGetV3QueryOptions = <
  TData = Awaited<ReturnType<typeof plansExternalDetailsBySetIdGetV3>>,
  TError = ErrorType<unknown>,
>(
  setId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansExternalDetailsBySetIdGetV3>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlansExternalDetailsBySetIdGetV3QueryKey(setId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof plansExternalDetailsBySetIdGetV3>>
  > = ({ signal }) =>
    plansExternalDetailsBySetIdGetV3(setId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!setId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof plansExternalDetailsBySetIdGetV3>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlansExternalDetailsBySetIdGetV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof plansExternalDetailsBySetIdGetV3>>
>;
export type PlansExternalDetailsBySetIdGetV3QueryError = ErrorType<unknown>;

export function usePlansExternalDetailsBySetIdGetV3<
  TData = Awaited<ReturnType<typeof plansExternalDetailsBySetIdGetV3>>,
  TError = ErrorType<unknown>,
>(
  setId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof plansExternalDetailsBySetIdGetV3>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlansExternalDetailsBySetIdGetV3QueryOptions(
    setId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
